import React from 'react';
import { AnimatedSection } from './AnimatedSection'; // Adjust path if needed

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <AnimatedSection>
          <div className="col-md-8 col-md-offset-2 section-title">
            <h2>Meet the Team</h2>
            <p>Built by creators, for creators. This is the Mahanc team.</p>
          </div>
        </AnimatedSection>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                  <div className="thumbnail">
                    {' '}
                    <img src={d.img} alt="..." className="team-img" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                      {d.fields && (
                        <ul>
                          {d.fields.map((field, index) => (
                            <li key={index}>{field}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  );
};
